/**
 * Category Entity Types
 *
 * Типы для сущности категорий услуг
 *
 * Используем типы из shared-types и расширяем их для frontend нужд
 */

import type { Category, CategoryTreeItem } from '@hummii/shared-types';

// Экспортируем типы и helpers из shared-types
export type {
  Category,
  RootCategory,
  Subcategory,
  // CategoryCard - excluded to avoid conflict with UI component CategoryCard
  CategoryWithSubcategories,
  CategoryTree,
  CategoryFilter,
  CategorySearchParams,
  CategoryOption,
  GroupedCategoryOptions,
  CategoryBreadcrumb,
  ContractorByCategoryParams,
  Locale,
} from '@hummii/shared-types';

// Re-export CategoryCard type from shared-types with alias
export type { CategoryCard as CategoryCardType } from '@hummii/shared-types';

// ✅ Экспортируем DTOs из shared-types
export type {
  GetCategoriesResponse,
  GetPopularCategoriesResponse,
  GetCategoryTreeResponse,
  GetSubcategoriesResponse,
  GetCategoryPathResponse,
  CategorySearchResponse,
  PopularCategoryItem,
  CategoryTreeItem,
  CategoryPathItem,
  // Request DTOs
  GetCategoriesQueryDto,
  SearchCategoriesQueryDto,
  CreateCategoryDto,
  UpdateCategoryDto,
} from '@hummii/shared-types';

export {
  getLocalizedName,
  getLocalizedDescription,
  categoryToOption,
  buildCategoryBreadcrumbs,
  isRootCategory,
  isSubcategory,
  buildCategoryTree,
  flattenCategoryTree,
  groupCategoriesByParent,
} from '@hummii/shared-types';

// Frontend-specific типы


/**
 * Props for CategoryCard component
 */
export interface CategoryCardProps {
  category: Category | CategoryTreeItem;
  subcategories?: CategoryTreeItem[];
  locale?: string;
  onClick?: (categoryId: string) => void;
  onSubcategoryClick?: (subcategorySlug: string) => void;
  className?: string;
}

/**
 * Props for CategoryList component
 */
export interface CategoryListProps {
  categories: Category[];
  locale?: string;
  onCategoryClick?: (categoryId: string) => void;
  className?: string;
}

/**
 * Category with UI enhancements
 * LEGACY: Used for old components that expect gradient/image fields
 */
export interface CategoryWithUI extends Category {
  gradient?: string; // Optional gradient for UI (legacy)
  image?: string; // Optional image URL for card background
}

// ✅ MIGRATION NOTE:
// - CategoryAPI больше не существует, используйте Category из shared-types
// - SearchResponse теперь называется CategorySearchResponse
// - Для popular endpoints используйте PopularCategoryItem если нужен _count